import { HttpRequest, HttpMethod } from "./http";

class AuthProvider extends HttpRequest {
    SignIn(params) {
        return this.request(HttpMethod.Post,`/api/auth/login`, params);
    }
    SignOut(params) {
        return this.request(HttpMethod.Post,`/api/auth/logout`, params);
    }
    ForgotPassword(params) {
        return this.request(HttpMethod.Post,`/api/auth/forgotpassword`, params);
    }
    ResetPassword(params) {
        return this.request(HttpMethod.Post,`/api/auth/resetpassword`, params);
    }
    GetProfile(params) {
        return this.request(HttpMethod.Get,`/api/v1/profile`);
    }
    ChangeProfile(params) {
        return this.request(HttpMethod.Put,`/api/v1/profile`, params);
    }
    ChangePassword(params) {
        return this.request(HttpMethod.Put,`api/v1/profile/password`, params);
    }
}

export default AuthProvider;
